import { isValidEmail } from '../../../services/UtilService';
import { dbPost } from '../../../apis/commonApi';
import getRendererClass from '../../../components/gridComponents/GridRendererClass';

class ExpertAnalyzeController {
  initialState = {
    email: 'a@b.com',
    name: '',
    position: '',
    age: 0,
  };

  constructor(
    store,
    modalService,
    validateService,
    [gridRef],
    { valueObj, setValueObj },
    { selectBoxData, setSelectBoxData },
    navigate
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.gridRef = gridRef;
    this.navigate = navigate;
    this.valueObj = { ...this.initialState, ...valueObj };
    this.setValueObj = setValueObj;
    this.selectBoxData = selectBoxData;
    this.setSelectBoxData = setSelectBoxData;

    this.gridCellClick = this.gridCellClick.bind(this);
    this.gridCellDblClick = this.gridCellDblClick.bind(this);
  }

  // 검색
  async fnSearch() {
    const { requestName, taskName, processStatus } = this.valueObj;
    const url = '/expert-analyze/list.do';
    const param = {
      userNm: requestName,
      taskNm: taskName,
      status: processStatus,
    };

    this.gridRef.current.doQuery(url, param).then(() => {
      this.fnHideColumnByAuth();
    });
  }

  // 전문가 분석 상태 목록 조회
  async fnGetStatusList() {
    const statusCd = 'S305';
    const url = '/expert-analyze/status/list.do';
    const param = {
      statusCd: statusCd,
    };
    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
      } else {
        this.setSelectBoxData(
          [...response].sort(function (a, b) {
            return a.seq < b.seq ? -1 : a.seq > b.seq ? 1 : 0;
          })
        );
      }
    } catch (error) {
      this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
    }
  }

  // 전문가 분석 신청
  async fnApplyExpertAnalyze(params) {
    const url = '/expert-analyze/apply.do';
    const param = {
      taskId: params.taskId,
      aiaAplyId: params.aiaAplyId,
      entNm: params.entNm,
      tpbizTypeNm: params.tpbizTypeNm,
      taskNm: params.taskNm,
    };
    let response;

    try {
      response = await dbPost(url, param);

      if (response instanceof Error) {
        this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
      } else {
        this.modalService.successAlert('신청이 완료되었습니다.', () => {
          // 전문가 분석 목록 재호출
          this.fnSearch();
        });
      }
    } catch (error) {
      this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
    }
  }

  // 권한별 컬럼 숨김
  fnHideColumnByAuth() {
    // 기업 사용자
    if (this.store.store.authrtId === 'ME') {
      this.gridRef.current.hideColumn('entNm');
      this.gridRef.current.hideColumn('tpbizTypeNm');
    } else if (this.store.store.authrtId === 'EX') {
      // this.gridRef.current.hideColumn('exprtNm');
    }
  }

  valueObjChange(model, value) {
    this.setValueObj({ ...this.valueObj, [model]: value });
  }

  gridCellClick(row, col, type) {
    const rowData = this.gridRef.current.getRowObj(row);
    // 상태 업데이트 API
    if (col === 'status' && type === 'BUTTON' && rowData.status === 'EXPRT01') {
      this.modalService.openModal('AnalyzeAgreeModal', {}, resultYn => {
        if (resultYn === 'Y') {
          this.fnApplyExpertAnalyze(rowData);
        }
      });
    }
  }

  gridCellDblClick(row, col, rowData) {
    if (rowData.status !== 'EXPRT01') {
      this.navigate('/expert/analyze/detail', {
        state: {
          rowData: rowData,
        },
      });
    }
  }
}

export default ExpertAnalyzeController;
